import React from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';
import { permissionsSelector } from 'common/state/account';
import SettingsHeader from 'modules/settings/components/SettingsHeader';
import DownloadTokensSection from 'modules/settings/components/DataExport/DownloadTokensSection';
import WebhooksSection from 'modules/settings/components/DataExport/WebhooksSection';
import NoAccess from 'modules/settings/components/DataExport/NoAccess';
import { SectionLoading } from 'modules/settings/components/DataExport/SectionStatus';
import { useCanManageDataExport } from 'modules/settings/hooks/dataExport';

/** Settings page where a customer's admins manage the download API tokens and webhooks of the customer data export. */
const DataExport = (): JSX.Element => {
  const { t } = useTranslation();
  const { canManage, isLoading } = useCanManageDataExport();
  const { user_edit: isAdmin } = useRecoilValue(permissionsSelector);

  // Settings routes are not guarded, so a deep link must not reach the sections (or their requests) without access.
  const renderContent = () => {
    if (isLoading) return <SectionLoading />;
    if (!canManage) return <NoAccess reason={isAdmin ? 'feature' : 'admin'} />;

    return (
      <>
        <DownloadTokensSection />
        <WebhooksSection />
      </>
    );
  };

  return (
    <div>
      <SettingsHeader title={t('dataExport.title')} subtitle={t('dataExport.subtitle')} sticky={false} />
      {renderContent()}
    </div>
  );
};

export default React.memo(DataExport);
